<div class="flex h-full overflow-hidden">
    <!-- Stepper on the left -->
    <div class="flex flex-col border-r border-customBorder p-10 h-full w-[380px]">
        <sh-stepper
            class="block h-full"
            color="primary"
            [value]="seasonStepper().selected + 1"
            [vertical]="true"
            (value-changed)="handleStepperValueChange($event)"
        >
            @for (step of steps; track step.label; let index = $index) {
                <sh-stepper-item
                    [label]="step.label"
                    [disabled]="disabledSteps().includes(index)"
                    [type]="seasonStepper().active > index ? 'success' : undefined"
                />
            }
        </sh-stepper>
    </div>

    <!-- Main content on the right -->
    <div class="flex-1 flex flex-col min-h-0 pl-32 pt-10">
        <header class="bg-transparent mb-4 flex justify-between items-center">
            <div>
                <h1 class="text-xl font-bold text-darkGraySubtitleColor">
                    {{ seasonInfo?.get('title')?.value || ('seasons.season-creation.no-title' | translate) }}
                </h1>
                <p class="bg-yellow-400 text-black text-xs font-semibold px-3 py-0 rounded-full inline-block">
                    {{ 'seasons.season-creation.draft' | translate }}
                </p>
            </div>
            <div class="flex space-x-5">
                <sh-button
                    color="secondary"
                    icon="cancel"
                    iconPosition="left"
                    layout="compact"
                    (click)="onCancel()"
                    ariaLabel="Cancel"
                    [label]="'seasons.season-creation.buttons.cancel' | translate"
                />
            </div>
        </header>
        <div class="h-px w-full bg-customBorder my-10"></div>

        @if (!isEditMode() || (isEditMode() && season())) {
            <form
                class="flex h-full min-h-0 flex-col"
                [formGroup]="seasonCreationForm"
                ngxsForm="seasonForm.seasonCreationForm"
                (ngSubmit)="onSubmit()"
            >
                <div class="pr-6 flex-1 min-h-0 overflow-y-auto">
                    <!-- Content based on the current step -->
                    @switch (currentStepIndex()) {
                        @case (0) {
                            <app-season-info [seasonInfo]="seasonInfo" />
                        }
                        @case (1) {
                            <app-timeframe [timeframe]="timeframe" />
                        }
                        @case (2) {
                            <app-budget [budget]="budget" />
                        }
                        @case (3) {
                            <app-social-criteria [socialCriteria]="socialCriteria" />
                        }
                        @case (4) {
                            <app-salary-weight [salaryWeight]="salaryWeight" />
                        }
                        @case (5) {
                            <app-summary
                                [timeframe]="timeframe"
                                [budget]="budget"
                                [socialCriteria]="socialCriteria"
                                [salaryWeight]="salaryWeight"
                            />
                        }
                    }
                </div>

                <div class="pt-4">
                    <div class="flex flex-row ml-auto justify-end space-x-5 pb-4">
                        @if (currentStepIndex() !== 0) {
                            <sh-button
                                color="tertiary"
                                icon="arrow-line-left-s"
                                iconPosition="left"
                                layout="compact"
                                (click)="onBack()"
                                ariaLabel="Back button"
                                [label]="'seasons.season-creation.buttons.back' | translate"
                            />
                        }
                        @if (currentStepIndex() !== 5) {
                            <sh-button
                                icon="arrow-line-right-s"
                                iconPosition="left"
                                layout="compact"
                                (click)="onNext()"
                                [disabled]="!isFromValidInCorrectStep"
                                ariaLabel="Next button"
                                [label]="'seasons.season-creation.buttons.next' | translate"
                            />
                        }
                        @if (currentStepIndex() === 5) {
                            <div class="relative min-w-[7rem]">
                                <sh-button
                                    class="w-full"
                                    size="max-content"
                                    color="primary"
                                    (click)="onSubmit()"
                                    [disabled]="isSavingSeason()"
                                    ariaLabel="Submit button"
                                    [label]="
                                        isSavingSeason()
                                            ? ''
                                            : season()?.id
                                              ? ('seasons.season-creation.buttons.update' | translate)
                                              : ('seasons.season-creation.buttons.save' | translate)
                                    "
                                />
                                @if (isSavingSeason()) {
                                    <sh-spinner class="pointer-events-none absolute inset-0" size="s" />
                                }
                            </div>
                        }
                    </div>
                </div>
            </form>
        } @else {
            <sh-spinner size="m" overlay />
        }
    </div>
</div>
